import { FC, useMemo } from "react";
import { useRecoilValue } from "recoil";

import {
  landingActiveStepErrorsAtom,
  LandingStepErrorsEnum,
} from "@ryde/utils-landings";

import {
  PassengerAlreadyRegisteredError,
  PermissionDeniedError,
} from "../../errors-template";

export const StepError: FC = () => {
  const activeStepErrors = useRecoilValue(landingActiveStepErrorsAtom);
  const { type } = activeStepErrors ?? {};

  const ErrorContentMap = useMemo(() => {
    switch (type) {
      case LandingStepErrorsEnum.PassengerAlreadyRegistered:
        return <PassengerAlreadyRegisteredError />;
      case LandingStepErrorsEnum.PassengerIsNotEligible:
      case LandingStepErrorsEnum.PassengerIsProbablyBlocked:
        return <PermissionDeniedError />;
      default:
        return null;
    }
  }, [type]);

  return (
    <>
      <div className="landing-top-illustration" aria-hidden="true"></div>
      {ErrorContentMap}
      <div className="landing-container-footer">
        <div className="landing-container-footer-logo" aria-hidden="true"></div>
      </div>
    </>
  );
};
